import { AlertCircle, Download, Loader2, Save } from 'lucide-react';

interface SaveErrorBannerProps {
  error: string;
  isSaving: boolean;
  onRetry: () => void;
  onDownloadBackup: () => void;
}

export function SaveErrorBanner({
  error,
  isSaving,
  onRetry,
  onDownloadBackup,
}: SaveErrorBannerProps) {
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3 mb-3 bg-red-50 border border-red-200 rounded-lg text-sm">
      <div className="flex items-center gap-2 text-red-800 min-w-0">
        <AlertCircle className="h-4 w-4 shrink-0" />
        <span className="truncate">
          <span className="font-medium">Save failed.</span>{' '}
          Your changes are still here but not saved to the server. {error}
        </span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          onClick={onRetry}
          disabled={isSaving}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50 transition-colors"
        >
          {isSaving ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <Save className="h-3.5 w-3.5" />
          )}
          Retry Save
        </button>
        <button
          type="button"
          onClick={onDownloadBackup}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-red-700 bg-white border border-red-300 rounded-md hover:bg-red-50 transition-colors"
        >
          <Download className="h-3.5 w-3.5" />
          Download Backup
        </button>
      </div>
    </div>
  );
}
